<mc-dialog (closeEvent)="close()">
  <div class="confirm-dialog">
    <h3 class="dialog-title">{{ confirmDialogTitle }}</h3>
    @if (confirmDialogInfo) {
      <div class="info-alert">
        <span>{{ confirmDialogInfo }}</span>
      </div>
    }
    <div class="dialog-actions">
      <mc-button (clickEvent)="close()" variant="stroked" color="primary">Cancel</mc-button>
      <mc-button (clickEvent)="confirm()" variant="flat" color="primary">{{ deleteButtonTitle }} </mc-button>
    </div>
  </div>
</mc-dialog>
